import { useState } from 'react';
import { Alert, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material';
import type { Hold } from 'api-client/models';
import { useAppContext, useHoldsApi } from '@/context/AppContext';
import { bookingError } from '../utils/bookingError';

export function BookingPrivateNotes({ hold, onSaved }: { hold: Hold; onSaved: (hold: Hold) => void }) {
  const { team } = useAppContext();
  const api = useHoldsApi();
  const promoter = hold.promoterTeam === team?.id;
  const [notes, setNotes] = useState((promoter ? hold.notes : hold.hostNotes) ?? '');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const save = async (): Promise<void> => {
    setPending(true); setError('');
    try {
      await api.holdsPartialUpdate({ id: hold.id, patchedHoldCreateUpdate: promoter ? { notes } : { hostNotes: notes } });
      onSaved(await api.holdsRetrieve({ id: hold.id }));
    } catch (reason) { setError(await bookingError(reason)); }
    finally { setPending(false); }
  };
  return <Card sx={{ my: 3 }}><CardContent><Stack spacing={2}>
    <Typography component="h2" variant="h6">Private workspace</Typography>
    <TextField label="Your team's private notes" multiline minRows={3} value={notes} disabled={pending}
      helperText="Only your active team can read these notes. They are never included in shared terms or change requests."
      onChange={event => setNotes(event.target.value)} />
    {error && <Alert severity="error">{error}</Alert>}
    <Button disabled={pending} onClick={() => void save()}>{pending ? 'Saving notes…' : 'Save private notes'}</Button>
  </Stack></CardContent></Card>;
}
